import type { BoxProps } from '@hover/blueprint';
import { Box, useTheme } from '@hover/blueprint';
import React from 'react';

import { BasicCard, CARD_PADDING } from './BasicCard';
import type { BasicCardProps } from './BasicCard';

export interface SplitCardProps extends BasicCardProps {
  imageBoxProps?: BoxProps;
  descriptionBoxProps?: BoxProps;
  backgroundImage?: string;
  children: React.ReactNode;
  onResponsiveChangeOrientation?: boolean;
}

export const SplitCard = ({
  backgroundImage,
  descriptionBoxProps,
  imageBoxProps,
  children,
  onResponsiveChangeOrientation,
  sx,
  ...props
}: SplitCardProps) => {
  const { colors } = useTheme();
  const bgColor = colors.neutral[0];

  return (
    <BasicCard
      backgroundColorProp={bgColor}
      hasShadow
      padding={0}
      sx={{
        flexDirection: {
          base: 'column',
          desktop: onResponsiveChangeOrientation ? 'row-reverse' : 'row',
        },
        ...sx,
      }}
      {...props}
    >
      <Box
        bgColor="neutral.100"
        bgImage={backgroundImage}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="cover"
        sx={{
          aspectRatio: {
            base: '4/3',
            desktop: onResponsiveChangeOrientation ? 'auto' : '',
          },
        }}
        width={{
          base: '100%',
          desktop: onResponsiveChangeOrientation ? '40%' : '',
        }}
        {...imageBoxProps}
      />
      <Box
        backgroundColor={bgColor}
        display="block"
        padding={CARD_PADDING}
        width={{
          base: '100%',
          desktop: onResponsiveChangeOrientation ? '60%' : '',
        }}
        {...descriptionBoxProps}
      >
        {children}
      </Box>
    </BasicCard>
  );
};
